import React from 'react';
import { Card, Button, Row, Col } from 'react-bootstrap';

const products = [
  { 
    id: '1', 
    title: "Graphene Sanitary Pad (XL)", 
    price: "₹39", 
    image: "img/Product-1.jpg",
    features: [
      "Soft & breathable material",
      "Odor lock technology",
      "All-day comfort"
    ]
  },
  { 
    id: '2', 
    title: "Herbal Sanitary Pad (XL)", 
    price: "₹25", 
    image: "img/Product-2.jpg",
    features: [
      "Infused with herbal extracts",
      "Skin-friendly & rash-free",
      "Extra absorbency"
    ]
  }
];

const ProductList = () => {
  const [hoveredCard, setHoveredCard] = React.useState(null);
  const [loaded, setLoaded] = React.useState(false);

  React.useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 100);
    return () => clearTimeout(timer);
  }, []);

  // Font style
  const fontStyle = {
    fontFamily: '"Playfair Display", serif'
  };

  return (
    <div 
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #fbe9f0, #fff)",
        padding: "20px",
        ...fontStyle
      }}
    >
      <div className="container py-4 text-center">
        <h2 
          className="mb-4 fw-bold"
          style={{
            fontSize: '2rem',
            color: 'black',
            position: 'relative',
            display: 'inline-block',
            paddingBottom: '10px',
            ...fontStyle,
            transform: loaded ? 'translateY(0)' : 'translateY(-20px)',
            opacity: loaded ? 1 : 0,
            transition: 'transform 0.6s cubic-bezier(0.34, 1.56, 0.64, 1), opacity 0.6s ease'
          }}
        >
          Our Products
          <span 
            style={{
              position: 'absolute',
              bottom: 0,
              left: '50%',
              width: '60px',
              height: '4px',
              background: '#e91e63',
              margin: '10px auto 0',
              borderRadius: '2px',
              transform: 'translateX(-50%)',
              transition: 'all 0.4s cubic-bezier(0.68, -0.6, 0.32, 1.6)',
              transformOrigin: 'center'
            }}
          />
        </h2>

        <Row className="g-4 mt-2 justify-content-center">
          {products.map((product, index) => (
            <Col xs={12} sm={6} md={4} key={product.id} className="mb-4 d-flex justify-content-center">
              <Card
                className="h-100 border-0 mx-3"
                style={{
                  transform: `
                    ${loaded ? 'translateY(0)' : 'translateY(30px)'}
                    ${hoveredCard === product.id ? 'translateY(-10px) rotateY(5deg)' : ''}
                  `,
                  opacity: loaded ? 1 : 0,
                  transition: `
                    transform ${0.3 + index * 0.1}s cubic-bezier(0.25, 0.46, 0.45, 0.94),
                    opacity ${0.3 + index * 0.1}s ease,
                    box-shadow 0.4s ease
                  `,
                  boxShadow: hoveredCard === product.id ? 
                    '0 15px 30px rgba(233, 30, 99, 0.2)' : 
                    '0 5px 15px rgba(0, 0, 0, 0.1)',
                  borderRadius: '12px',
                  overflow: 'hidden',
                  position: 'relative',
                  zIndex: hoveredCard === product.id ? 1 : 0
                }}
                onMouseEnter={() => setHoveredCard(product.id)}
                onMouseLeave={() => setHoveredCard(null)}
              >
                <div 
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    background: 'linear-gradient(135deg, rgba(255,255,255,0.9) 0%, rgba(248,248,248,0.9) 100%)',
                    zIndex: 0
                  }}
                />
                
                <div 
                  style={{
                    position: 'relative',
                    zIndex: 1,
                    overflow: 'hidden',
                    height: '200px'
                  }}
                >
                  <Card.Img
                    variant="top"
                    src={product.image}
                    alt={product.title}
                    className="img-fluid"
                    style={{
                      height: '100%',
                      width: '100%',
                      objectFit: 'contain',
                      transition: 'transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
                      transform: hoveredCard === product.id ? 'scale(1.1)' : 'scale(1)',
                      filter: hoveredCard === product.id ? 
                        'brightness(1.05) saturate(1.1)' : 
                        'brightness(1) saturate(1)'
                    }}
                    onError={(e) => {
                      e.target.src = 'https://via.placeholder.com/300x200?text=Product+Image';
                    }}
                  />
                </div>
                
                <Card.Body 
                  className="d-flex flex-column"
                  style={{ position: 'relative', zIndex: 1 }}
                >
                  <Card.Title 
                    className="fs-6"
                    style={{
                      transition: 'color 0.3s ease',
                      color: hoveredCard === product.id ? '#E91E63' : '#333',
                      ...fontStyle
                    }}
                  >
                    {product.title}
                  </Card.Title>
                  
                  <Card.Text 
                    className="fw-bold mb-2"
                    style={{
                      fontSize: '1.2rem',
                      transition: 'all 0.3s ease',
                      transform: hoveredCard === product.id ? 'scale(1.1)' : 'scale(1)',
                      color: hoveredCard === product.id ? '#0d6efd' : '#333',
                      ...fontStyle
                    }}
                  >
                    {product.price}
                  </Card.Text>

                  {/* ✅ Product Features */}
                  <ul 
                    className="text-start mb-3"
                    style={{ fontSize: '0.9rem', color: '#555', paddingLeft: '20px', ...fontStyle }}
                  >
                    {product.features.map((feature, i) => (
                      <li key={i}>{feature}</li>
                    ))}
                  </ul>
                  
                  <div className="mt-auto">
                    <Button
                      variant="primary"
                      className="w-100 border-0"
                      style={{
                        background: hoveredCard === product.id ? 
                          'linear-gradient(135deg, #0b5ed7, #E91E63)' : 
                          'linear-gradient(135deg, #0d6efd, #0b5ed7)',
                        transition: 'all 0.4s cubic-bezier(0.68, -0.6, 0.32, 1.6)',
                        transform: hoveredCard === product.id ? 
                          'translateY(-3px) scale(1.05)' : 
                          'translateY(0) scale(1)',
                        boxShadow: hoveredCard === product.id ? 
                          '0 5px 15px rgba(13, 110, 253, 0.4)' : 
                          '0 2px 10px rgba(13, 110, 253, 0.3)',
                        position: 'relative',
                        overflow: 'hidden',
                        ...fontStyle
                      }}
                    >
                      <span style={{ position: 'relative', zIndex: 2 }}>Buy Now</span>
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
};

export default ProductList;
